!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.mk = t());
}(this, function () {
  "use strict";

  return [{
    locale: "mk",
    pluralRuleFunction: function pluralRuleFunction(e, t) {
      var o = String(e).split("."),
        r = o[0],
        a = o[1] || "",
        i = !o[1],
        l = r.slice(-1),
        n = r.slice(-2),
        s = a.slice(-1),
        u = a.slice(-2);
      return t ? 1 == l && 11 != n ? "one" : 2 == l && 12 != n ? "two" : 7 != l && 8 != l || 17 == n || 18 == n ? "other" : "many" : i && 1 == l && 11 != n || 1 == s && 11 != u ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "година",
        relative: {
          0: "оваа година",
          1: "следната година",
          "-1": "минатата година"
        },
        relativeTime: {
          future: {
            one: "за {0} година",
            other: "за {0} години"
          },
          past: {
            one: "пред {0} година",
            other: "пред {0} години"
          }
        }
      },
      "year-short": {
        displayName: "год.",
        relative: {
          0: "оваа година",
          1: "следната година",
          "-1": "минатата година"
        },
        relativeTime: {
          future: {
            one: "за {0} год.",
            other: "за {0} год."
          },
          past: {
            one: "пред {0} год.",
            other: "пред {0} год."
          }
        }
      },
      month: {
        displayName: "месец",
        relative: {
          0: "овој месец",
          1: "следниот месец",
          "-1": "минатиот месец"
        },
        relativeTime: {
          future: {
            one: "за {0} месец",
            other: "за {0} месеци"
          },
          past: {
            one: "пред {0} месец",
            other: "пред {0} месеци"
          }
        }
      },
      "month-short": {
        displayName: "мес.",
        relative: {
          0: "овој месец",
          1: "следниот месец",
          "-1": "минатиот месец"
        },
        relativeTime: {
          future: {
            one: "за {0} месец",
            other: "за {0} месеци"
          },
          past: {
            one: "пред {0} месец",
            other: "пред {0} месеци"
          }
        }
      },
      day: {
        displayName: "ден",
        relative: {
          0: "денес",
          1: "утре",
          2: "задутре",
          "-2": "завчера",
          "-1": "вчера"
        },
        relativeTime: {
          future: {
            one: "за {0} ден",
            other: "за {0} дена"
          },
          past: {
            one: "пред {0} ден",
            other: "пред {0} дена"
          }
        }
      },
      "day-short": {
        displayName: "ден",
        relative: {
          0: "денес",
          1: "утре",
          2: "задутре",
          "-2": "завчера",
          "-1": "вчера"
        },
        relativeTime: {
          future: {
            one: "за {0} ден",
            other: "за {0} дена"
          },
          past: {
            one: "пред {0} ден",
            other: "пред {0} дена"
          }
        }
      },
      hour: {
        displayName: "час",
        relative: {
          0: "часов"
        },
        relativeTime: {
          future: {
            one: "за {0} час",
            other: "за {0} часа"
          },
          past: {
            one: "пред {0} час",
            other: "пред {0} часа"
          }
        }
      },
      "hour-short": {
        displayName: "ч.",
        relative: {
          0: "часов"
        },
        relativeTime: {
          future: {
            one: "за {0} час",
            other: "за {0} часа"
          },
          past: {
            one: "пред {0} час",
            other: "пред {0} часа"
          }
        }
      },
      minute: {
        displayName: "минута",
        relative: {
          0: "оваа минута"
        },
        relativeTime: {
          future: {
            one: "за {0} минута",
            other: "за {0} минути"
          },
          past: {
            one: "пред {0} минута",
            other: "пред {0} минути"
          }
        }
      },
      "minute-short": {
        displayName: "мин.",
        relative: {
          0: "оваа минута"
        },
        relativeTime: {
          future: {
            one: "за {0} мин.",
            other: "за {0} мин."
          },
          past: {
            one: "пред {0} мин.",
            other: "пред {0} мин."
          }
        }
      },
      second: {
        displayName: "секунда",
        relative: {
          0: "сега"
        },
        relativeTime: {
          future: {
            one: "за {0} секунда",
            other: "за {0} секунди"
          },
          past: {
            one: "пред {0} секунда",
            other: "пред {0} секунди"
          }
        }
      },
      "second-short": {
        displayName: "сек.",
        relative: {
          0: "сега"
        },
        relativeTime: {
          future: {
            one: "за {0} сек.",
            other: "за {0} сек."
          },
          past: {
            one: "пред {0} сек.",
            other: "пред {0} сек."
          }
        }
      }
    }
  }];
});